<template>
  <div>
    <b-container class="clear-margin clear-padding" fluid>
      <b-alert v-if="!isOwner" show class="p-2" variant="primary"
        >Billing is managed by {{ owner.firstName }} {{ owner.lastName }} ({{ owner.email }}) please contact them for any changes
      </b-alert>
    </b-container>
    <b-container class="clear-margin clear-padding" fluid>
      <b-row align-h="between">
        <b-col cols="8" class="text-start">
          <h4>Subscription</h4>
          <h6 class="text-muted">Account information and change subscription plan</h6>
        </b-col>
        <b-col cols="4" class="text-end">
          <b-button v-if="isOwner" variant="primary" class="mt-1 mr-1" size="sm" @click="onChangePlan()">Change plan</b-button>
        </b-col>
      </b-row>
    </b-container>
    <div class="mt-1"></div>
    <b-container class="clear-margin clear-padding">
      <b-row class="mb-1">
        <b-col col xs="12" sm="1" class="text-start">
          Owner:
        </b-col>
        <b-col cols xs="12" sm="10" class="text-start">
          <b>
            {{ owner.firstName }} {{ owner.lastName }} -
            <a class="underline" :href="`mailto:${owner.email}`">{{ owner.email }}</a>
          </b>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col col xs="12" sm="1" class="text-start">
          Plan:
        </b-col>
        <b-col cols xs="12" sm="10" class="text-start">
          <div>
            <b>{{ subscription.productName }}</b>
          </div>
          <small class="text-muted">{{ subscription.subscriptionId }}</small>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col col xs="12" sm="1" class="text-start">
          Licenses:
        </b-col>
        <b-col cols xs="12" sm="10" class="text-start">
          <b>{{ users.length }} of {{ subscription.quantity }} </b>
          licenses have been activated
          <b>({{ totalAvailableLicenses }} remaining)</b>
          <span v-if="isOwner">
            -
          </span>
          <b v-if="enableUpdateUsers && isOwner" class="text-primary underline">
            <a @click="onChangeLicensesCount()">Change number of licenses</a>
          </b>
          <span v-if="!enableUpdateUsers && isOwner" class="text-muted">Upgrade your subscription to increase your license count</span>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col col xs="12" sm="1" class="text-start">
          Price:
        </b-col>
        <b-col cols xs="12" sm="10" class="text-start">
          <b>{{ price }} / month</b>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col col xs="12" sm="1" class="text-start">
          Status:
        </b-col>
        <b-col cols xs="12" sm="10" class="text-start">
          <div class="d-flex align-center">
            <div class="circle mr-05"></div>
            <b>Active</b>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <billing-update-modal></billing-update-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Ripple from 'vue-ripple-directive'
import { BButton, BContainer, BRow, BCol, BAlert } from 'bootstrap-vue'
import BillingUpdateModal from './UpdateBillingModal.vue'

export default {
  components: { BButton, BContainer, BRow, BCol, BillingUpdateModal, BAlert },
  directives: {
    Ripple
  },
  data: function() {
    return {}
  },
  setup() {},
  computed: {
    ...mapState('userProfile', ['profile']),
    ...mapState('billing', ['customerId', 'organisationIds', 'subscription', 'owner', 'users', 'vaults', 'pricingDetails']),
    totalAvailableLicenses() {
      if (this.subscription.quantity - this.users.length < 0) {
        return 0
      }
      return this.subscription.quantity - this.users.length
    },
    price: {
      get() {
        const pricingDetail = this.pricingDetails.find(x => x.id === this.subscription.priceId)
        if (pricingDetail) {
          return `${pricingDetail.currency === 'usd' ? '$' : '£'} ${(
            (pricingDetail.unit_amount / 100) *
            this.subscription.quantity
          ).toLocaleString('en', { useGrouping: true })}`
        } else {
          return 'N/A'
        }
      }
    },
    isOwner: {
      get() {
        return this.profile._id === this.owner._id
      }
    },
    enableUpdateUsers: {
      get() {
        return this.subscription.productName !== 'Basic'
      }
    }
  },
  watch: {},

  methods: {
    onChangePlan() {
      this.$router.push({ name: 'billing-price-plans' })
    },
    onChangeLicensesCount() {
      this.$store.dispatch('billingUpdateModal/onChangeModal', {
        self: this,
        visible: true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_variables';

.circle {
  border-radius: 50%;
  width: 10px;
  height: 10px;
  background: $primary;
}

.align-center {
  align-items: center;
}

.mr-05 {
  margin-right: 0.5rem;
}
</style>
